import util from '../util'
import _ from 'lodash'
import Vue from 'vue'

/**
 * 分页对象构造方法
 * @param option
 * @param loadAtOnce 是否立即加载
 */
function page(option, loadAtOnce = true) {
    this.option = option || {};
    if (this.defaultOption) {
        let defaultOption = this.defaultOption();
        for (let key in defaultOption) {
            if (_.isUndefined(this.option[key]))
                Vue.set(this.option, key, defaultOption[key])
        }
    }
    if (loadAtOnce)
        this.execute()
}

page.prototype.defaultOption = function () {
    return {
        currentPage: 1,//当前页数
        pageSize: 10,//每页多少条
        list: [],//分页数据
        total: 0,//总条数
        needTotal: true,//是否需要查询总条数
        callback: undefined,//加载完数据回调
        url: undefined,//用于服务器分页
        data: undefined,//用于本地分页数据源
        params: undefined,
        filter: undefined//用于本地分页数据筛选
    }
}

page.prototype.execute = function () {
    if (this.option.url)
        this.severPage()
    else
        this.localPage()
}

/**
 * 服务器后台分页方式
 */
page.prototype.severPage = function () {
    util.axios.post(this.option.url, {
            needTotal: this.option.needTotal,
            offset: (this.option.currentPage - 1) * this.option.pageSize,
            limit: this.option.pageSize,
            params: this.option.params
        }
    ).then(data => {
        this.option.total = data.total;
        this.option.list = data.list;
        if (!data.list || !data.list.length) {//没有数据时自动查询最近有数据的页数
            if (this.option.needTotal) {//需要后台查询总数的情况下根据后台返回的总数判断
                let newCurrentPage = Math.ceil(data.total / this.option.pageSize)
                if (this.option.currentPage != newCurrentPage) {
                    if(newCurrentPage>0){
                        this.option.currentPage = newCurrentPage
                        this.severPage()
                    }else{
                        this.option.currentPage = 1
                        this.doCallback()
                    }
                } else
                    this.doCallback()
            } else {//没有后台查询总数的情况下自动查询上一页是否有数据
                if (this.option.currentPage > 1) {
                    this.option.currentPage--
                    this.severPage()
                } else
                    this.doCallback()
            }
        } else
            this.doCallback();
    });
}

/**
 * 本地分页方式
 */
page.prototype.localPage = function () {
    let temporaryData = this.option.data || (this.option.data = [])
    if (this.option.filter)
        temporaryData = temporaryData.filter(this.option.filter)
    this.option.total = temporaryData.length
    let offset = (this.option.currentPage - 1) * this.option.pageSize
    if (offset >= temporaryData.length) {
        this.option.currentPage = Math.ceil(temporaryData.length / this.option.pageSize)
        offset = (this.option.currentPage - 1) * this.option.pageSize
    }
    this.option.list = temporaryData.slice(offset, offset + this.option.pageSize)
    this.doCallback();
}


/**
 * 执行回调
 */
page.prototype.doCallback = function () {
    if (this.option.callback)
        this.option.callback(this.option.list, this)
}

export default page